import React, {useState} from 'react'

import Drawer from '../NavigationDrawer/NavigationDrawer'
import { useAuth } from '../AuthProvider/AuthProvider'
import HamburgerIcon from '../../assets/hamburger.svg'

import './Hamburger.css'
import { onEnterOrSpace } from '../../utils/key-handler'

const Hamburger = () => {
  const { user, authenticated } = useAuth()
  const [isOpen, setOpen] = useState()
  const keyHandler = onEnterOrSpace(() => setOpen(true))
  return (
    <React.Fragment>
      <div data-testid='hamburger' onClick={() => setOpen(true)} onKeyPress={keyHandler} styleName='hamburger' tabIndex='0' role='button' >
        <HamburgerIcon styleName='icon' />
        {authenticated && (
          <p data-testid='hamburger-welcome-user-name' styleName='welcome'>
            Welcome{user.firstName ? `, ${user.firstName}` : ''}!
          </p>
        )}
      </div>
      {isOpen && <Drawer onClose={() => setOpen(false)} />}
    </React.Fragment>
  )
}

export default Hamburger
